import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import SubHeader from 'components/SubHeader';
import { CSVLink } from 'react-csv';
import { ROUTES } from 'shared/constants/routes';
import SearchBar from 'components/SearchBar';
import OrderModal from 'pages/warehouse/orderModal';
import UpdateOrderStatusModal from 'pages/warehouse/UpdateOrdersModal';
import EcoIcon from '@material-ui/icons/Eco';
import { USD_TO_CAD_CONVERSION_RATE } from 'constants/currency';
import {
  getAllSubmittedOrders,
  searchAllSubmittedOrders,
  machineOrderDetails,
  updateOrderStatus,
  updateSavedOrderData,
  submitOrderToCanada,
  submitOrderToUSA,
  filterAllSubmittedOrders,
  orderShippedNotification,
  closeShopifyOrder,
  getTrackingCANumber,
  getTrackingUSNumber,
  allSubmittedOrdersForProduct,
} from 'actions/orders';
import Pagination from 'components/Pagination';
import USAFlag from 'assets/images/usa-flag.png';
import CADFlag from 'assets/images/canada-flag.png';
import EUFlag from 'assets/images/eu-flag.png';
import AUFlag from 'assets/images/aus-flag.jpeg';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import Select from 'components/Select';
import Stripe from 'components/Stripe';
import Tooltip from '@material-ui/core/Tooltip';
import Button from 'components/Button';
import COLORS from 'shared/constants/colors';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { default as MUISelect } from '@material-ui/core/Select';
import BulkOrderSummary from 'pages/warehouse/BulkOrderSummary';
import {
  stripeCharge,
  getAllCards,
  updateChargeInformation,
} from 'actions/stripe';
import { getSearchedSubmittedUsers } from 'actions/user';
import {
  Container,
  Wrapper,
  SearchWrapper,
  Heading,
  OrderWrapper,
  OrderCard,
  Orders,
  PaginationWrapper,
  FilterWrapper,
  DaysAgo,
  ProductsWrapper,
} from 'styles/pages/warehouse';
const XMLParser = require('react-xml-parser');
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: 400,
  },
}));

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];

const Warehouse = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const csvEl = useRef(null);
  const products = useSelector((state) => state?.products?.data);
  const token = useSelector((state) => state?.auth?.profile?.token);
  const [selectedProducts, setProducts] = useState([]);
  const [csvData, setCsvData] = useState(null);
  const [selectedModalUser, setUser] = useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const [allSubmittedOrders, setAllSubmittedOrders] = useState(undefined);
  const [category, setCategory] = useState(undefined);
  const [categoryValue, setCategoryValue] = useState(undefined);
  const [filterPayload, setFilterPayload] = useState(undefined);
  const [selectedOrder, setSelectedOrder] = useState(undefined);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedCards, setSelectedCards] = useState(undefined);
  const [bulkOrderModal, setBulkOrderModal] = useState(false);
  const [
    updateOrderStatusModalVisibility,
    setUpdateOrderStatusModalVisibility,
  ] = useState({ open: false });

  const take = 20;

  useEffect(async () => {
    let query = '';
    if (selectedProducts?.length == 1) {
      query = {
        'ShirtlyOrderData.OrderLines': {
          $elemMatch: {
            OrderLineItems: {
              $elemMatch: { ProductID: selectedProducts[0] },
            },
          },
        },
      };
    } else if (selectedProducts?.length > 1) {
      query = {
        $or: selectedProducts?.map((p) => ({
          'ShirtlyOrderData.OrderLines': {
            $elemMatch: {
              OrderLineItems: { $elemMatch: { ProductID: p } },
            },
          },
        })),
      };
    }

    const orders =
      selectedProducts?.length > 0
        ? await dispatch(
            allSubmittedOrdersForProduct({
              query,
              skip: (currentPage === 0 ? currentPage : currentPage - 1) * take,
              take,
            })
          )
        : filterPayload?.payload
        ? await dispatch(
            filterAllSubmittedOrders({
              ...filterPayload.payload,
              skip: (currentPage === 0 ? currentPage : currentPage - 1) * take,
              take,
            })
          )
        : filterPayload?.query
        ? await dispatch(
            allSubmittedOrdersForProduct({
              query: filterPayload.query,
              skip: (currentPage === 0 ? currentPage : currentPage - 1) * take,
              take,
            })
          )
        : await dispatch(
            getAllSubmittedOrders(
              {
                skip:
                  (currentPage === 0 ? currentPage : currentPage - 1) * take,
                take,
              },
              token
            )
          );
    if (orders.error) {
      return;
    }
    setAllSubmittedOrders(orders);
  }, [dispatch, currentPage, filterPayload]);

  return (
    <>
      <Container>
        <SubHeader
          title={ROUTES.WAREHOUSE.TITLE}
          links={[
            {
              title: ROUTES.HOME.TITLE,
              to: ROUTES.HOME.LINK,
            },
          ]}
          currentPageTitle={ROUTES.WAREHOUSE.TITLE}
        />

        <Wrapper>
          <SearchWrapper>
            <SearchBar
              searchById={async (v) => {
                if (filterPayload) {
                  setCategory(undefined);
                  setCategoryValue(undefined);
                }

                const order = await dispatch(
                  searchAllSubmittedOrders({
                    ReceiptID: v,
                  })
                );

                if (order.error) {
                  return;
                }

                setAllSubmittedOrders(order);
              }}
              fetchAllOrders={() => {
                if (filterPayload) {
                  setCategory(undefined);
                  setCategoryValue(undefined);
                }
                setCurrentPage(0);
              }}
            />

            <Button
              title="Generate Late Orders Report"
              containerStyle={{
                background: '#000',
                boxShadow: 'none',
                height: '34px',
                textTransform: 'capitalize',
                color: COLORS.WHITE,
              }}
              onClick={() =>
                setUpdateOrderStatusModalVisibility({ open: true, csv: true })
              }
            />
            <Button
              title="Update All Orders"
              containerStyle={{
                background: '#000',
                boxShadow: 'none',
                height: '34px',
                textTransform: 'capitalize',
                color: COLORS.WHITE,
              }}
              onClick={() =>
                setUpdateOrderStatusModalVisibility({ open: true })
              }
            />
          </SearchWrapper>

          <FilterWrapper>
            <Select
              label="Filter"
              options={['Marketplace', 'Status', 'PrintProvider', 'Print Type']}
              value={category}
              onChange={(value) => setCategory(value)}
            />
            {!!category && (
              <Select
                label="Filter Value"
                options={
                  category == 'Marketplace'
                    ? ['Shopify', 'Big Oven Tees', 'WooCommerce']
                    : category === 'Status'
                    ? ['InProduction', 'Shipped', 'Cancelled']
                    : category == 'PrintProvider'
                    ? ['CA', 'US', 'AU', 'EU']
                    : ['EMB', 'SUB', 'AOP', 'DURASOFT']
                }
                value={categoryValue}
                onChange={(value) => {
                  setProducts([]);
                  setCategoryValue(value);
                  let payload = {};
                  if (category === 'Marketplace') {
                    payload = {
                      payload: { marketPlace: value },
                    };
                  } else if (category === 'Status') {
                    payload = {
                      payload: { status: value },
                    };
                  } else if (category === 'PrintProvider') {
                    payload = {
                      payload: { printProvider: value },
                    };
                  } else {
                    payload = {
                      query: {
                        'ShirtlyOrderData.OrderLines': {
                          $elemMatch: {
                            OrderLineItems: {
                              $elemMatch: { PrintType: value },
                            },
                          },
                        },
                      },
                    };
                  }

                  setFilterPayload(payload);
                  setCurrentPage(0);
                }}
              />
            )}
          </FilterWrapper>

          <ProductsWrapper>
            <div>
              <FormControl className={classes.formControl}>
                <InputLabel>Products</InputLabel>
                <MUISelect
                  multiple
                  value={selectedProducts}
                  onChange={(event) => setProducts(event.target.value)}
                  input={<Input />}
                >
                  {products.map((p) => (
                    <MenuItem key={p?.Product?.ID} value={p?.Product?.ID}>
                      {p?.Product?.DisplayName}
                    </MenuItem>
                  ))}
                </MUISelect>
              </FormControl>
            </div>
            <div>
              <Button
                disabled={selectedProducts?.length === 0}
                title="Get Orders"
                containerStyle={{
                  background: COLORS.BLUE,
                  boxShadow: 'none',
                  height: '34px',
                  textTransform: 'capitalize',
                  color: COLORS.WHITE,
                }}
                onClick={async () => {
                  let query = '';
                  if (selectedProducts?.length == 1) {
                    query = {
                      'ShirtlyOrderData.OrderLines': {
                        $elemMatch: {
                          OrderLineItems: {
                            $elemMatch: { ProductID: selectedProducts[0] },
                          },
                        },
                      },
                    };
                  } else {
                    query = {
                      $or: selectedProducts?.map((p) => ({
                        'ShirtlyOrderData.OrderLines': {
                          $elemMatch: {
                            OrderLineItems: { $elemMatch: { ProductID: p } },
                          },
                        },
                      })),
                    };
                  }

                  const orders = await dispatch(
                    allSubmittedOrdersForProduct({
                      query,
                      skip: 0,
                      take,
                    })
                  );

                  if (orders.error) {
                    return;
                  }
                  setAllSubmittedOrders(orders);
                }}
              />

              <Button
                disabled={selectedProducts?.length === 0}
                title="Print Orders Summary"
                containerStyle={{
                  background: COLORS.BLUE,
                  boxShadow: 'none',
                  height: '34px',
                  textTransform: 'capitalize',
                  color: COLORS.WHITE,
                  marginLeft: 20,
                }}
                onClick={async () => {
                  setBulkOrderModal(true);
                }}
              />

              <Button
                disabled={selectedProducts?.length === 0}
                title="Remove Selected Products"
                containerStyle={{
                  background: 'red',
                  boxShadow: 'none',
                  height: '34px',
                  textTransform: 'capitalize',
                  color: COLORS.WHITE,
                  marginLeft: 20,
                }}
                onClick={async () => {
                  setProducts([]);
                  const orders = await dispatch(
                    getAllSubmittedOrders(
                      {
                        skip: 0,
                        take,
                      },
                      token
                    )
                  );

                  if (orders.error) {
                    return;
                  }

                  setAllSubmittedOrders(orders);
                }}
              />
            </div>
          </ProductsWrapper>

          <Orders>
            <Heading>
              All Orders&nbsp;({allSubmittedOrders?.orderCounts?.TotalOrders})
            </Heading>
            <OrderWrapper>
              {allSubmittedOrders?.orders ? (
                allSubmittedOrders?.orders?.map((order, index) =>
                  order?.ShirtlyOrderData?.ReceiptID ? (
                    <OrderCard
                      key={`order${index}`}
                      onClick={async () => {
                        const user = await dispatch(
                          getSearchedSubmittedUsers({
                            searchUser:
                              order?.ShirtlyOrderData?.MasterUserEmail,
                            skip: 1,
                            take: 1,
                          })
                        );
                        setUser({
                          password:
                            user?.users[0]?.UserData?.User?.PasswordHash,
                          email: order?.ShirtlyOrderData?.MasterUserEmail,
                        });

                        let isOrderPushedToMachine = true;
                        let machineStatusData = undefined;

                        if (
                          order?.ShirtlyOrderData?.Status === 'InProduction' ||
                          order?.ShirtlyOrderData?.Status === 'Shipped'
                        ) {
                          const isEU =
                            order?.ShirtlyOrderData?.PrintProvider === 'EU';

                          const isAU =
                            order?.ShirtlyOrderData?.PrintProvider === 'AU';

                          machineStatusData =
                            isAU || isEU
                              ? await dispatch(
                                  machineOrderDetails({
                                    PrintProvider: 'AU',
                                    orderPo: order?.ShirtlyOrderData?.ReceiptID,
                                  })
                                )
                              : await dispatch(
                                  machineOrderDetails({
                                    PrintProvider:
                                      order?.ShirtlyOrderData?.PrintProvider,
                                    orderPo: order?.ShirtlyOrderData?.ReceiptID,
                                    source: order?.ShirtlyOrderData?.PickUp
                                      ? 'Admin_PickUp'
                                      : undefined,
                                  })
                                );

                          isOrderPushedToMachine =
                            isAU || isEU
                              ? null
                              : !machineStatusData?.string?._text.includes(
                                  'No Order found'
                                );

                          if (
                            (isAU || isEU) &&
                            order?.ShirtlyOrderData?.Status === 'InProduction'
                          ) {
                            const status =
                              machineStatusData?.status ||
                              machineStatusData?.msg[0]?.order_status;

                            if (
                              status === 'shipped' ||
                              status === 'Shipped' ||
                              status === 'sent' ||
                              status === 'Sent'
                            ) {
                              const shipDate =
                                isAU || isEU
                                  ? moment(
                                      machineStatusData?.events?.find(
                                        (e) => e?.action === 'shipped'
                                      )?.time
                                    ).format('MM/DD/YYYY')
                                  : machineStatusData?.ship_date ||
                                    moment().format('YYYY-MM-DD');

                              const trackingNumber =
                                isAU || isEU
                                  ? machineStatusData?.events?.find(
                                      (e) => e?.action === 'shipped'
                                    )?.trackingUrl
                                  : machineStatusData?.tracking_number;

                              await dispatch(
                                updateOrderStatus({
                                  user: order?.ShirtlyOrderData
                                    ?.MasterUserEmail,
                                  orderId: order?.ShirtlyOrderData?.ID,
                                  status: 'Shipped',
                                  trackingNumber,
                                  shipDate,
                                })
                              );

                              await dispatch(
                                updateSavedOrderData({
                                  orderId: order?.ShirtlyOrderData?.ID,
                                  trackingNumber,
                                  shipDate,
                                })
                              );

                              await dispatch(
                                orderShippedNotification({
                                  order: order?.ShirtlyOrderData,
                                  orderId: order?.ShirtlyOrderData?.ID,
                                  trackingNumber,
                                  shipDate,
                                })
                              );

                              if (
                                order?.ShirtlyOrderData?.Store?.MarketplaceType ===
                                'Shopify'
                              ) {
                                await dispatch(
                                  closeShopifyOrder({
                                    shopName: order?.ShirtlyOrderData?.Store?.ShopName,
                                    orderId: order?.ShirtlyOrderData?.ID,
                                    user: order?.ShirtlyOrderData?.MasterUserEmail,
                                    trackingNumber:trackingNumber?.toString()
                                  })
                                );
                              }
                            }
                          }

                          if (isOrderPushedToMachine) {
                            const parsedMachineStatusData =
                              new XMLParser().parseFromString(
                                machineStatusData.string._text
                              );

                            const shipped =
                              parsedMachineStatusData.getElementsByTagName(
                                'Shipped'
                              );

                            const trackingNumber =
                              parsedMachineStatusData.getElementsByTagName(
                                'trackingNumber'
                              );
                            const shipDate =
                              parsedMachineStatusData.getElementsByTagName(
                                'shipDate'
                              );

                            if (
                              shipped[0]?.value === 'true' &&
                              order?.ShirtlyOrderData?.Status === 'InProduction'
                            ) {
                              await dispatch(
                                updateOrderStatus({
                                  user: order?.ShirtlyOrderData
                                    ?.MasterUserEmail,
                                  orderId: order?.ShirtlyOrderData?.ID,
                                  status: 'Shipped',
                                  trackingNumber: trackingNumber[0]?.value,
                                  shipDate: moment(shipDate[0]?.value).format(
                                    'YYYY-MM-DD'
                                  ),
                                })
                              );

                              await dispatch(
                                updateSavedOrderData({
                                  orderId: order?.ShirtlyOrderData?.ID,
                                  trackingNumber: trackingNumber[0]?.value,
                                  shipDate: moment(shipDate[0]?.value).format(
                                    'YYYY-MM-DD'
                                  ),
                                })
                              );

                              await dispatch(
                                orderShippedNotification({
                                  order: order?.ShirtlyOrderData,
                                  orderId: order?.ShirtlyOrderData?.ID,
                                  trackingNumber: trackingNumber[0]?.value,
                                  shipDate: moment(shipDate[0]?.value).format(
                                    'YYYY-MM-DD'
                                  ),
                                })
                              );
                              if (
                                order?.ShirtlyOrderData?.Store?.MarketplaceType ===
                                'Shopify'
                              ) {
                                await dispatch(
                                  closeShopifyOrder({
                                    shopName: order?.ShirtlyOrderData?.Store?.ShopName,
                                    orderId: order?.ShirtlyOrderData?.ID,
                                    user: order?.ShirtlyOrderData?.MasterUserEmail,
                                    trackingNumber:trackingNumber[0]?.value?.toString()
                                  })
                                );
                              }
                            } else if (
                              order?.ShirtlyOrderData?.Status !== 'Shipped'
                            ) {
                              let response;
                              if (
                                order?.ShirtlyOrderData?.PrintProvider === 'US'
                              ) {
                                response = await dispatch(
                                  getTrackingUSNumber({
                                    orderId: order?.ShirtlyOrderData?.ReceiptID,
                                  })
                                );
                              } else {
                                response = await dispatch(
                                  getTrackingCANumber({
                                    orderId: order?.ShirtlyOrderData?.ReceiptID,
                                  })
                                );
                              }
                              if (response?.shipments?.length > 0) {
                                await dispatch(
                                  updateOrderStatus({
                                    user: order?.ShirtlyOrderData
                                      ?.MasterUserEmail,
                                    orderId: order?.ShirtlyOrderData?.ID,
                                    status: 'Shipped',
                                    trackingNumber:
                                      response?.shipments[0].trackingNumber,
                                    shipDate: moment(
                                      response?.shipments[0].shipDate
                                    ).format('YYYY-MM-DD'),
                                  })
                                );

                                await dispatch(
                                  updateSavedOrderData({
                                    orderId: order?.ShirtlyOrderData?.ID,
                                    trackingNumber:
                                      response?.shipments[0].trackingNumber,
                                    shipDate: moment(
                                      response?.shipments[0].shipDate
                                    ).format('YYYY-MM-DD'),
                                  })
                                );

                                await dispatch(
                                  orderShippedNotification({
                                    order: order?.ShirtlyOrderData,
                                    orderId: order?.ShirtlyOrderData?.ID,
                                    trackingNumber:
                                      response?.shipments[0].trackingNumber,
                                    shipDate: moment(
                                      response?.shipments[0].shipDate
                                    ).format('YYYY-MM-DD'),
                                  })
                                );
                                if (
                                  order?.ShirtlyOrderData?.Store?.MarketplaceType ===
                                  'Shopify'
                                ) {
                                  await dispatch(
                                    closeShopifyOrder({
                                      shopName: order?.ShirtlyOrderData?.Store?.ShopName,
                                      orderId: order?.ShirtlyOrderData?.ID,
                                      user: order?.ShirtlyOrderData?.MasterUserEmail,
                                      trackingNumber:
                                      response?.shipments[0].trackingNumber?.toString()
                                    })
                                  );
                                }
                              }
                            }
                          }
                        }

                        setSelectedOrder({
                          ...order,
                          isOrderPushedToMachine,
                          DataForMachine:
                            order?.ShirtlyOrderData?.PrintProvider === 'AU'
                              ? machineStatusData
                              : machineStatusData?.string?._text,
                        });
                      }}
                    >
                      {order?.ShirtlyOrderData?.PackingMode === 'eco' && (
                        <Tooltip title="Eco Bag Order" placement="top">
                          <EcoIcon
                            style={{
                              color: 'green',
                              position: 'absolute',
                              top: 5,
                              right: 36,
                              height: 26,
                              width: 26,
                            }}
                          />
                        </Tooltip>
                      )}

                      {order?.StripeChargeInfo?.status === 'succeeded' ||
                      order?.PaypalChargeInfo?.status === 'APPROVED' ||
                      order?.PaypalChargeInfo?.status === 'COMPLETED' ||
                      order?.PaypalChargeInfo?.status === 'CAPTURED' ? (
                        <CheckCircleIcon
                          style={{
                            color: 'green',
                            position: 'absolute',
                            top: 5,
                            right: 5,
                          }}
                        />
                      ) : (
                        <HourglassFullIcon
                          style={{
                            color: 'orange',
                            position: 'absolute',
                            top: 5,
                            right: 5,
                          }}
                        />
                      )}

                      <Tooltip
                        title="Submit To Production Date"
                        placement="top"
                      >
                        <DaysAgo
                          background={
                            order?.ShirtlyOrderData?.Status === 'InProduction'
                              ? moment().diff(
                                  order?.OrderSubmitToProductionDate,
                                  'days'
                                ) <= 5
                                ? 'orange'
                                : 'red'
                              : order?.ShirtlyOrderData?.Status === 'Shipped'
                              ? 'green'
                              : 'red'
                          }
                        >
                          {moment().diff(
                            order?.OrderSubmitToProductionDate,
                            'days'
                          )}
                          &nbsp;days ago
                        </DaysAgo>
                      </Tooltip>

                      <h3>Order {order?.ShirtlyOrderData?.ReceiptID}</h3>
                      <h5>
                        Marketplace:&nbsp;
                        <b
                          style={{
                            fontSize: 17,
                            color:
                              order?.ShirtlyOrderData?.Marketplace == 'Etsy'
                                ? 'orange'
                                : order?.ShirtlyOrderData?.Marketplace ==
                                  'Shopify'
                                ? 'green'
                                : order?.ShirtlyOrderData?.Marketplace ==
                                  'WooCommerce'
                                ? '#7f54b3'
                                : '#000',
                          }}
                        >
                          {order?.ShirtlyOrderData?.Marketplace}
                        </b>
                      </h5>

                      <h5>Print Providers:</h5>
                      <span>
                        <img
                          alt="flag"
                          src={
                            order?.ShirtlyOrderData?.PrintProvider === 'US'
                              ? USAFlag
                              : order?.ShirtlyOrderData?.PrintProvider === 'CA'
                              ? CADFlag
                              : order?.ShirtlyOrderData?.PrintProvider === 'EU'
                              ? EUFlag
                              : AUFlag
                          }
                        />
                        Shirtly {order?.ShirtlyOrderData?.PrintProvider}
                      </span>
                      <h3
                        className={
                          order?.ShirtlyOrderData?.Status == 'Shipped'
                            ? 'status-green'
                            : order?.ShirtlyOrderData?.Status == 'InProduction'
                            ? 'status-orange'
                            : 'status-red'
                        }
                      >
                        {order?.ShirtlyOrderData?.Status}
                      </h3>
                    </OrderCard>
                  ) : null
                )
              ) : (
                <div>No orders found!</div>
              )}
            </OrderWrapper>
          </Orders>

          {allSubmittedOrders?.orderCounts?.TotalOrders && (
            <PaginationWrapper>
              <Pagination
                totalCount={allSubmittedOrders?.orderCounts?.TotalOrders}
                take={take}
                page={currentPage}
                onChange={(e, v) => setCurrentPage(v)}
              />
            </PaginationWrapper>
          )}
        </Wrapper>
      </Container>
      {!!selectedOrder && (
        <OrderModal
          user={selectedModalUser}
          order={selectedOrder}
          modal={!!selectedOrder}
          setModal={() => {
            setSelectedOrder(undefined);
            setUser(undefined);
          }}
          sendOrderToPlant={async () => {
            const xml =
              `<AddXml xmlns="http://tempuri.org/">
          <OrderString>` +
              selectedOrder?.DataForMachine?.replaceAll('&', ' and ') +
              '</OrderString></AddXml>';
            const submitOrderResponse =
              selectedOrder?.ShirtlyOrderData?.PrintProvider === 'CA'
                ? await dispatch(
                    submitOrderToUSA(xml?.replace(/>\s+</g, '><'), token)
                  )
                : await dispatch(
                    submitOrderToCanada(xml?.replace(/>\s+</g, '><'), token)
                  );

            const parseOrderResponse = new XMLParser().parseFromString(
              submitOrderResponse
            );

            const errorCode =
              parseOrderResponse.getElementsByTagName('ErrorCode');

            if (errorCode?.length) {
              if (errorCode[0].value != 0) {
                alert(
                  'Error with the order, please contact shirtly for more details at support@shirtly.com'
                );
                return;
              }
            }
            setSelectedOrder(undefined);
          }}
          pushOrderToMachine={async () => {
            const xml = selectedOrder?.DataForMachine?.replaceAll('&', ' and ');

            const submitOrderResponse =
              selectedOrder?.ShirtlyOrderData?.PrintProvider === 'CA'
                ? await dispatch(
                    submitOrderToCanada(xml?.replace(/>\s+</g, '><'), token)
                  )
                : await dispatch(
                    submitOrderToUSA(xml?.replace(/>\s+</g, '><'), token)
                  );

            const parseOrderResponse = new XMLParser().parseFromString(
              submitOrderResponse
            );

            const errorCode =
              parseOrderResponse.getElementsByTagName('ErrorCode');

            if (errorCode?.length) {
              if (errorCode[0].value != 0) {
                alert(
                  'Error with the order, please contact shirtly for more details at info@bigoventees.com'
                );
                return;
              }
            }
            setSelectedOrder(undefined);
          }}
          openModalPayment={async () => {
            if (!selectedCards) {
              const cards = await dispatch(
                getAllCards({
                  user: selectedOrder?.ShirtlyOrderData?.MasterUserEmail,
                })
              );

              if (cards.error) {
                return;
              }

              setSelectedCards(cards);
            }

            setPaymentModal(true);
          }}
        />
      )}
      {paymentModal && (
        <Stripe
          payableAmount={
            selectedOrder?.ShirtlyOrderData?.FulfillmentPlusShipping
          }
          open={paymentModal}
          cards={selectedCards}
          showSaveCardCheckbox={false}
          hide={async (data) => {
            if (data) {
              const payload = {
                user: selectedOrder?.ShirtlyOrderData?.MasterUserEmail,
                saveCard: false,
                cardDetails: data?.cardDetails,
                // amount: 100,
                ID: selectedOrder?.ShirtlyOrderData?.ID,
                currency: data?.paymentInCanadian ? 'CAD' : 'USD',
                ReceiptID: selectedOrder?.ShirtlyOrderData?.ReceiptID,
                amount: data.paymentInCanadian
                  ? parseInt(
                      selectedOrder?.ShirtlyOrderData?.FulfillmentPlusShipping *
                        USD_TO_CAD_CONVERSION_RATE +
                        (selectedOrder?.ShirtlyOrderData
                          ?.FulfillmentPlusShipping *
                          USD_TO_CAD_CONVERSION_RATE *
                          13) /
                          100
                    ).toFixed(2) * 100
                  : parseInt(
                      selectedOrder?.ShirtlyOrderData?.FulfillmentPlusShipping *
                        100
                    ),
              };

              const charge = await dispatch(stripeCharge(payload, token));
              if (charge.error) {
                return;
              }
              if (
                !charge ||
                !charge?.status ||
                charge?.status !== 'succeeded' ||
                charge?.statusCode === 402 ||
                charge?.statusCode === 400 ||
                charge?.type === 'StripeCardError' ||
                charge?.type === 'StripeInvalidRequestError' ||
                charge?.rawType === 'card_error' ||
                charge?.rawType === 'invalid_request_error' ||
                charge?.code === 'card_declined'
              ) {
                alert('Payment declined');
                return;
              }

              await dispatch(
                updateChargeInformation({
                  orderId: selectedOrder?.ShirtlyOrderData?.ID,
                  chargeData: charge,
                })
              );

              setPaymentModal(false);
              setSelectedCards(undefined);
              setCurrentPage(0);
            } else {
              setPaymentModal(false);
              setSelectedCards(undefined);
            }
          }}
        />
      )}
      {updateOrderStatusModalVisibility?.open && (
        <UpdateOrderStatusModal
          open={updateOrderStatusModalVisibility?.open}
          csv={updateOrderStatusModalVisibility?.csv}
          setOpen={({ open, orders }) => {
            if (orders?.length && updateOrderStatusModalVisibility?.csv) {
              let csvData = [
                [
                  'Order#',
                  'Email',
                  'Submit To Production Date',
                  'Shipping Address',
                  'Ship Date',
                  'Delay Days',
                  'Print Provider',
                  'Tracking Number',
                ],
              ];

              for (let i = 0; i < orders?.length; i++) {
                const order = orders[i];
                const ShirtlyOrderData = order?.ShirtlyOrderData;
                const {
                  ID,
                  MasterUserEmail,
                  PrintProvider,
                  BuyerName,
                  AddressLineOne,
                  AddressLineTwo,
                  City,
                  ZipPostal,
                  StateProvince,
                  CountryString,
                } = ShirtlyOrderData;

                const orderSubmitToProductionDate =
                  order?.OrderSubmitToProductionDate;

                const diff = moment().diff(orderSubmitToProductionDate, 'days');

                csvData.push([
                  `BOT-${ID}`,
                  MasterUserEmail,
                  orderSubmitToProductionDate,
                  `${BuyerName}\n${AddressLineOne} ${AddressLineTwo} ${City} ${StateProvince} ${ZipPostal}, ${CountryString}`,
                  '',
                  `${diff} Days`,
                  `${PrintProvider} Plant`,
                  '',
                ]);
              }
              setCsvData(csvData);

              setTimeout(() => {
                csvEl.current.link.click();
              }, 10);
            } else {
              setCsvData(undefined);
            }

            setUpdateOrderStatusModalVisibility({
              open: open,
              csv: false,
            });
          }}
        />
      )}

      {bulkOrderModal && (
        <BulkOrderSummary
          modal={bulkOrderModal}
          setModal={(v) => setBulkOrderModal(v)}
          orders={allSubmittedOrders}
        />
      )}

      {csvData && (
        <CSVLink
          style={{ display: 'none' }}
          ref={csvEl}
          data={csvData}
          filename={`BOT_Late_Orders_Report(${moment().format(
            'MMM DD YYYY'
          )}).xls`}
        />
      )}
    </>
  );
};

export default Warehouse;
